<template>
  <div class="understanding-card">
    <div class="understanding-card__section">
      <div class="understanding-card__label">我将按这个问题分析</div>
      <div class="understanding-card__problem">{{ card.standard_problem }}</div>
    </div>

    <div class="understanding-card__section">
      <div class="understanding-card__label">优先检索方向</div>
      <div class="understanding-card__directions">
        <el-tag
          v-for="dir in card.search_directions"
          :key="dir"
          class="understanding-card__dir"
          type="info"
          effect="plain"
        >{{ dir }}</el-tag>
      </div>
    </div>

    <div
      v-if="card.uncertain_but_ok && card.uncertain_but_ok.length"
      class="understanding-card__section"
    >
      <div class="understanding-card__label">暂不确定，但不影响开始</div>
      <div class="understanding-card__uncertain">{{ card.uncertain_but_ok.join('、') }}</div>
    </div>

    <div class="understanding-card__actions">
      <el-button type="primary" class="understanding-card__btn--primary" @click="$emit('start')">
        继续分析
      </el-button>
      <el-button class="understanding-card__btn" @click="$emit('revise')">改一下理解</el-button>
    </div>
  </div>
</template>

<script setup>
defineProps({
  card: {
    type: Object,
    required: true
  }
})

defineEmits(['start', 'revise', 'quickStart'])
</script>

<style scoped lang="scss">
.understanding-card {
  width: 100%;
  padding: 20px 24px;
  border-radius: 16px;
  background: #fff;
  border: 1px solid #ebeef5;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06);
  box-sizing: border-box;

  &__section {
    margin-bottom: 16px;

    &:last-of-type {
      margin-bottom: 20px;
    }
  }

  &__label {
    font-size: 13px;
    color: #909399;
    margin-bottom: 8px;
  }

  &__problem {
    font-size: 16px;
    font-weight: 500;
    color: #303133;
    line-height: 1.6;
  }

  &__directions {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
  }

  &__dir {
    font-size: 13px;
  }

  &__uncertain {
    font-size: 14px;
    color: #909399;
    line-height: 1.6;
  }

  &__actions {
    display: flex;
    gap: 12px;
    border-top: 1px solid #f0f2f5;
    padding-top: 16px;
  }

  &__btn--primary {
    min-width: 120px;
    background-color: #409EFF;
    border-color: #409EFF;

    &:hover {
      background-color: #2c6eb0;
      border-color: #2c6eb0;
    }
  }
}
</style>
